import * as Sentry from '@sentry/react';

type SentryEnv = {
  dsn: string | undefined;
  environment: string;
  release: string | undefined;
};

const env: SentryEnv = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_GIT_SHA,
};

let initialized = false;

export function initSentry(): void {
  if (initialized) return;
  if (!env.dsn) return;

  Sentry.init({
    dsn: env.dsn,
    environment: env.environment,
    release: env.release,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // MVP: errors only — no distributed tracing. Revisit when traffic justifies.
    tracesSampleRate: 0,
    replaysSessionSampleRate: env.environment === 'production' ? 0.0 : 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  initialized = true;
}

export function setSentryUserContext(scope: {
  tenantId: string;
  userId: string;
  email: string;
}): void {
  Sentry.setUser({ id: scope.userId, email: scope.email });
  Sentry.setTag('tenant_id', scope.tenantId);
}

export function clearSentryUserContext(): void {
  Sentry.setUser(null);
  Sentry.setTag('tenant_id', '');
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
